import { Helmet } from 'react-helmet'
import {
  AggregatorLogExportButton,
  AggregatorLogTable,
} from 'components/logsAggregator'

const AggregatorApi = () => {
  return (
    <>
      <Helmet>
        <title>ORMS AGGREGATORS API Logs </title>
      </Helmet>
      <AggregatorLogExportButton />
      <AggregatorLogTable />
    </>
  )
}

export default AggregatorApi
